export default __webpack_public_path__ + "static/media/iconMap.c9838f61.svg";